/**
 * @param {HTMLElement | null | undefined} anchorEl
 * @returns {number | undefined}
 */
export const getAnchorLayerZIndex = (anchorEl) => {
  if (!anchorEl || typeof window === "undefined") {
    return undefined;
  }

  let node = anchorEl;
  let layerZIndex = 0;

  while (node && node !== document.documentElement) {
    const { zIndex, position } = window.getComputedStyle(node);
    const parsed = Number.parseInt(zIndex, 10);

    if (parsed > 0 && position !== "static") {
      layerZIndex = Math.max(layerZIndex, parsed);
    }

    node = node.parentElement;
  }

  return layerZIndex > 0 ? layerZIndex : undefined;
};

/**
 * Portals the callout into the same UI layer as the anchor when possible.
 *
 * @param {HTMLElement | null | undefined} anchorEl
 * @returns {HTMLElement}
 */
export const getCalloutContainer = (anchorEl) => {
  if (!anchorEl || typeof document === "undefined") {
    return document.body;
  }

  return (
    anchorEl.closest(".MuiDialog-container") ??
    anchorEl.closest(".MuiDrawer-root") ??
    anchorEl.closest("[role='dialog']") ??
    document.body
  );
};
